// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"featured-sidebar-items_uk-open__PxlQ0","grecaptcha-badge":"featured-sidebar-items_grecaptcha-badge__0B6DK","title":"featured-sidebar-items_title__er2DF","list":"featured-sidebar-items_list__rW9yc"};
    if(module.hot) {
      // 1793877043017
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  